export default __webpack_public_path__ + "static/media/phone.142ae767.svg";